import { TawzeefLogo } from "@/shared/components/TawzeefLogo";
import { useEffect, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { acquirePageLoadingLock } from "@/shared/lib/pageLoadingLock";

const subscribeToClient = () => () => {};

export function AppLoadingState({
  label = "Loading Tawzeef administration…",
}: {
  label?: string;
}) {
  const client = useSyncExternalStore(subscribeToClient, () => true, () => false);
  useEffect(acquirePageLoadingLock, []);
  const loading = (
    <div
      data-page-loading="true"
      aria-busy="true"
      aria-label={label}
      aria-live="polite"
      className="app-loading"
      role="status"
    >
      <div aria-hidden="true" className="app-loading__glow app-loading__glow--top" />
      <div aria-hidden="true" className="app-loading__glow app-loading__glow--bottom" />
      <div className="app-loading__logo">
        <TawzeefLogo />
      </div>
    </div>
  );
  return client && typeof document !== "undefined" && document.body
    ? createPortal(loading, document.body)
    : loading;
}
